import React from "react";
import { CardResponse } from "../../../Interfaces/CardResponse";
import { Card } from "../Card/Card";
import { LARGE_IMG, SMALL_IMG } from "../../../constants/App";
import _get from 'lodash/get';
import './MenuCardList.scss';
import { ternaryCheck } from "../../../Utils/WindowUtils";
interface MenuCardListProps {
    cardListData: CardResponse[],
    sourceComponent: string,
    dictionaryLables?: any,
    onAnchorClick?:any,
    categoryName?:string
}

const MenuCardList: React.FC<MenuCardListProps> = ({ cardListData, sourceComponent, dictionaryLables, onAnchorClick, categoryName= "" }) => {
    return (
        <div className="menu__list">
            {cardListData?.map((card: CardResponse, index: number) => {
                return (
                    <Card
                        index={_get(card, ["categoryId"], index)}
                        key={_get(card, ["categoryId"], "")}
                        title={_get(card, ["name"], "")}
                        imageURL={_get(card, ["imageUrl"], "")}
                        imageLayout={
                            ternaryCheck(_get(card, ["wide"], true),
                                LARGE_IMG,
                                SMALL_IMG)
                        }
                        description={_get(card, ["shortDescription"], "")}
                        redirectURL={_get(card, ["categoryUrl"], "#")}
                        onAnchorClick={e => {
                            window.orderViewModel.categoryDisplayName = categoryName;
                            window.orderViewModel.save();
                            onAnchorClick(e, card)
                        }}
                        testAutoIds={{
                            badgeTitleTestAutoId: `${sourceComponent}-category-badge-title-${index}`,
                            cardTitleTestAutoId: `${sourceComponent}-category-title-${index}`,
                            cardDescriptionTestAutoId: `${sourceComponent}-category-card-desc-${index}`,
                            cardImageTestAutoId: `${sourceComponent}-category-image-${index}`
                        }}
                        imageSize={card.wide ? LARGE_IMG : SMALL_IMG}
                        comboBrightPrice={_get(card, ["minBundledPrice"],null)}
                        cardTextData={[
                            { key: 'from', value: dictionaryLables?.from },
                            { key: 'outOfStock', value: dictionaryLables?.outOfStock }
                          ]}
                    ></Card>
                );
            })}
        </div>
    )
}
export default MenuCardList;